import { createAction, props } from '@ngrx/store';

export const selectCandidateForSideDrawerSuccess = createAction(
  '[Talent Pool Page] Select User For Side Drawer Success',
  props<{
    id: number;
  }>(),
);
